import React, { useContext, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useRouter } from 'next/router';
import { Main } from '@components/layout/Layout';
import { EmailValidationBanner, IosBanner } from '@ecosystems/banner';
import Header from '@ecosystems/navigations/header/Header';
import VideosSubHeader from '@ecosystems/navigations/VideosSubHeader';
import Footer from '@organisms/Footer';
import { UserContext } from '@lib/contexts/UserProvider';
import TrialAvailableBanner from '@organisms/stripeBanners/TrialAvailableBanner';
import PaymentConfirmationModal from '@organisms/modals/paymentConfirmation/PaymentConfirmationModal';
// import { ChallengeOfferBanners } from '@organisms/stripeBanners/ChallengeOfferBanners';
import YearlyOffer from '@organisms/stripeBanners/YearlyOffer';

const Overlay = styled.div<{ shown: boolean }>`
  position: fixed;
  display: ${props => (props.shown ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  cursor: pointer;
`;

const VIDEO_SUBHEADER_ROUTES = [
  '/[lang]/videos/genres/[genre]',
  '/[lang]/program',
  '/[lang]/playlists',
  '/blog',
];

const Layout = props => {
  const router = useRouter();
  const [currentUser] = useContext(UserContext);
  const theme = useContext(ThemeContext);

  const [isMenuLayerActive, setIsMenuLayerActive] = useState(false);

  const handleCloseMenuLayer = () => {
    setIsMenuLayerActive(false);
    document.body.style.overflow = 'visible';
  };

  const handleOpenMenuLayer = () => {
    setIsMenuLayerActive(true);
    if (window.innerWidth >= theme.viewports.mobile) {
      document.body.style.overflow = 'hidden';
    }
  };

  if (router.route === '/[lang]/maintenance') {
    return <Main>{props.children}</Main>;
  }

  return (
    <>
      <TrialAvailableBanner />
      <Header
        isMenuLayerActive={isMenuLayerActive}
        openMenuLayer={handleOpenMenuLayer}
        closeMenuLayer={handleCloseMenuLayer}
      />
      {VIDEO_SUBHEADER_ROUTES.includes(router.route) && <VideosSubHeader />}
      {currentUser?.isEmailActivated === false ? (
        <EmailValidationBanner currentUser={currentUser} />
      ) : null}
      {(router.route === `/video` || router.route === `/playlist`) && (
        <IosBanner />
      )}
      <YearlyOffer />
      {router.query['order_id'] ? (
        <PaymentConfirmationModal
          open={true}
          orderId={router.query?.order_id as string}
        />
      ) : null}
      <Main>
        <Overlay shown={isMenuLayerActive} onClick={handleCloseMenuLayer} />
        {props.children}
      </Main>
      <Footer />
    </>
  );
};

export default Layout;
